import { PaginationItem } from "./PaginationItem";
import { usePaginationButton } from "./usePaginationButton";

export interface PaginationButtonProps {
  defaultPage?: number;
  onClick: (page: number) => void;
  totalPages: number;
}

export const PaginationButton = ({
  onClick,
  totalPages,
  defaultPage = 1,
}: PaginationButtonProps) => {
  const { items = [] }: any = usePaginationButton({
    count: totalPages,
    defaultPage,
    onClick,
  });

  if (totalPages <= 1) {
    return null;
  }

  return (
    <nav className="flex gap-2">
      {items.map(({ page, type, selected, ...item }: any, index: any) => (
        <PaginationItem
          key={`pagination-item-${type}-${index}`}
          page={page}
          type={type}
          selected={selected}
          index={index}
          {...item}
        />
      ))}
    </nav>
  );
};
